export const FAMILY_DISEASE_HISTORY_TITLE = 'Histórico de doenças na família';

/** Rótulo do blob medicalHistory (mesmo padrão das outras linhas, sem acento). */
export const FAMILY_DISEASE_HISTORY_BLOB_LABEL = 'Historico de doencas na familia';

export const FAMILY_RELATIVE_KEYS = [
  'father',
  'mother',
  'children',
  'siblings',
  'grandparents',
] as const;

export type FamilyRelativeKey = (typeof FAMILY_RELATIVE_KEYS)[number];

export const FAMILY_RELATIVE_LABELS: Record<FamilyRelativeKey, string> = {
  father: 'Pai',
  mother: 'Mãe',
  children: 'Filhos',
  siblings: 'Irmãos',
  grandparents: 'Avós',
};

export type FamilyRelativeAnswer = {
  hasDisease: boolean | null;
  description: string;
};

export type FamilyDiseaseHistory = Record<FamilyRelativeKey, FamilyRelativeAnswer>;

export function emptyFamilyRelativeAnswer(): FamilyRelativeAnswer {
  return { hasDisease: null, description: '' };
}

export function emptyFamilyDiseaseHistory(): FamilyDiseaseHistory {
  return {
    father: emptyFamilyRelativeAnswer(),
    mother: emptyFamilyRelativeAnswer(),
    children: emptyFamilyRelativeAnswer(),
    siblings: emptyFamilyRelativeAnswer(),
    grandparents: emptyFamilyRelativeAnswer(),
  };
}

export function serializeFamilyRelativeRow(
  key: FamilyRelativeKey,
  row: FamilyRelativeAnswer,
): string {
  const label = FAMILY_RELATIVE_LABELS[key];
  if (row.hasDisease === true) {
    const description = row.description.trim();
    return description ? `${label}: Sim - ${description}` : `${label}: Sim`;
  }
  if (row.hasDisease === false) {
    return `${label}: Não`;
  }
  return `${label}: Não informado`;
}

export function serializeFamilyDiseaseHistory(history: FamilyDiseaseHistory): string {
  return FAMILY_RELATIVE_KEYS.map((key) => serializeFamilyRelativeRow(key, history[key])).join('; ');
}

export function validateFamilyDiseaseHistory(
  history: FamilyDiseaseHistory,
): string | null {
  for (const key of FAMILY_RELATIVE_KEYS) {
    const row = history[key];
    const label = FAMILY_RELATIVE_LABELS[key];
    if (row.hasDisease !== true && row.hasDisease !== false) {
      return `Informe Sim ou Não para ${label}.`;
    }
    if (row.hasDisease === true && !row.description.trim()) {
      return `Descreva as doenças de ${label}.`;
    }
  }
  return null;
}
